import tippingScreenshot from "@/assets/tipping-screenshot.png";

export default function TippingMockup() {
  return (
    <div className="w-full max-w-[280px] md:max-w-none mx-auto md:mx-0 md:ml-auto flex flex-col items-center">
      <img
        src={tippingScreenshot}
        alt="Send It tipping page showing Australian Grand Prix matchups"
        className="w-full md:h-[520px] md:w-auto md:object-contain rounded-2xl shadow-2xl"
        loading="lazy"
      />

      <p className="mt-4 text-center text-xs text-muted-foreground">
        Pole + 11 race tips every weekend. That's it.
      </p>
    </div>
  );
}
